export const adminOrganizationImageTranslation = (params: { organizationId: number; imageType: string }) =>
  `organizationId:${params.organizationId},imageType:${params.imageType}`;
